import * as CalcSelectors from 'store/calculation/calculation';
import { MAP_SELECTORS } from '../constants/map-selectors';

export const useCalcSelectors = () => {
  const getTotalPricePages = projectKey => {
    return MAP_SELECTORS[projectKey]
      ? CalcSelectors[MAP_SELECTORS[projectKey]['totalPricePages']]
      : CalcSelectors['selectDefaultPagesTotal'];
  };

  const getTotalPriceOptions = projectKey => {
    return MAP_SELECTORS[projectKey]
      ? CalcSelectors[MAP_SELECTORS[projectKey]['totalPriceOptions']]
      : CalcSelectors['selectDefaultOptionsTotal'];
  };

  const getTotalPrice = projectKey => {
    return MAP_SELECTORS[projectKey]
      ? CalcSelectors[MAP_SELECTORS[projectKey]['totalPrice']]
      : CalcSelectors['selectDefaultTotal'];
  };

  const getDiscount = projectKey => {
    return MAP_SELECTORS[projectKey]
      ? CalcSelectors[MAP_SELECTORS[projectKey]['discount']]
      : CalcSelectors['selectDefaultDiscount'];
  };

  const getEta = projectKey => {
    return MAP_SELECTORS[projectKey]
      ? CalcSelectors[MAP_SELECTORS[projectKey]['eta']]
      : CalcSelectors['selectDefaultEta'];
  };

  const getTotalPriceForAsap = projectKey => {
    return MAP_SELECTORS[projectKey]
        ? CalcSelectors[MAP_SELECTORS[projectKey]['totalPriceForAsap']]
        : CalcSelectors['selectDefaultTotalForAsap'];
  };

  return {
    getTotalPricePages,
    getTotalPriceOptions,
    getTotalPrice,
    getDiscount,
    getEta,
    getTotalPriceForAsap
  };
};
